import { useEffect, useMemo, useState } from 'react'
import '../SocialHiveSettings.css'
import { useLanguage } from '../../../../../LanguageProvider';
import SHInput from '../../../components/SHInput/SHInput';
import { FiChevronDown, FiEdit2, FiTrash2 } from 'react-icons/fi';
import Services from '../../../../../services/Services';
import { useToaster } from '../../../../../ToasterProvider';
import UniversalTable from '../../../../../components/UniversalTable/UniversalTable'; // yolu gerekirse düzelt

export default function SocailHiveSettingsAuthorization({ selectedChannel }) {
  const token = localStorage.getItem("token")
  const { getTranslation } = useLanguage();
  const { toastSuccess } = useToaster();
  const [activeTab, setActiveTab] = useState('assign');
  const [userJoinedLeft, setUserJoinedLeft] = useState({});

  const permissions = [
    'Yetki izni adı 01',
    'Yetki izni adı 02',
    'Yetki izni adı 03',
    'Yetki izni adı 04',
    'Yetki izni adı 05',
  ];
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const colorOptions = [
    { name: getTranslation("blue"), value: '#4A90E2' },
    { name: getTranslation("red"), value: '#E24A4A' },
    { name: getTranslation("teal"), value: '#4AE2A5' },
    { name: getTranslation("pink"), value: '#E24ADE' },
    { name: getTranslation("orange"), value: '#E2A54A' },
  ];
  const [roleName, setRoleName] = useState('');
  const [roleColor, setRoleColor] = useState(colorOptions[0].value);
  const [roleTypes, setRoleTypes] = useState([
    { name: 'Oluşturulmuş yetki adı 01', color: '#4A90E2' },
    { name: 'Oluşturulmuş yetki adı 02', color: '#E24A4A' },
    { name: 'Oluşturulmuş yetki adı 03', color: '#4AE2A5' },
    { name: 'Oluşturulmuş yetki adı 04', color: '#E24ADE' },
    { name: 'Oluşturulmuş yetki adı 05', color: '#E2A54A' },
  ]);

  const [users, setUsers] = useState([]);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [newUser, setNewUser] = useState('');

  // --- Services ---
  const getChannelUsers = () => {
    Services.SocialHiveGetChannelUsers(token, selectedChannel.channelID)
      .then((res) => {
        if (res.data.status) setUsers(res.data.result);
        else setUsers([]);
      })
      .catch(() => setUsers([]));
  };

  const getDailyJoinLeaveReport = () => {
    Services.SocialHiveChannelDailyJoinLeaveReport(token, selectedChannel.channelID)
      .then((res) => {
        if (res.data.status) setUserJoinedLeft(res.data.result);
      })
      .catch(() => setUsers([]));
  };

  const getChannelUserRequests = () => {
    Services.SocialHiveGetChannelUserRequests(token, selectedChannel.channelID)
      .then((res) => {
        if (res.data.status) setPendingUsers(res.data.result);
        else setPendingUsers([]);
      })
      .catch(() => setPendingUsers([]));
  };

  useEffect(() => {
    getDailyJoinLeaveReport();
    getChannelUsers();
    getChannelUserRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- Handlers (permissions / roles) ---
  const handlePermissionChange = (perm) => {
    setSelectedPermissions((p) =>
      p.includes(perm) ? p.filter((x) => x !== perm) : [...p, perm]
    );
  };

  const handleCreateRole = () => {
    if (!roleName) return;
    setRoleTypes((prev) => [...prev, { name: roleName, color: roleColor }]);
    setRoleName('');
    setSelectedPermissions([]);
    setRoleColor(colorOptions[0].value);
  };

  const handleDeleteRole = (idx) => {
    setRoleTypes((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleEditRole = (idx) => {
    const r = roleTypes[idx];
    setRoleName(r.name);
    setRoleColor(r.color);
    setActiveTab('create');
  };

  // --- Handlers (admin / requests) ---
  const toggleAdmin = (user) => {
    if (user.isAdmin === false) makeUserAdmin(user);
    else takeUserAdmin(user);
  };

  const makeUserAdmin = (user) => {
    Services.SocialHiveAssignAdminToChannel(token, selectedChannel.channelID, user.id)
      .then((res) => {
        if (res.data.status) {
          const upd = [...users];
          user.isAdmin = true;
          setUsers(upd);
        }
      })
      .catch(() => setUsers([]));
  };

  const takeUserAdmin = (user) => {
    Services.SocialHiveRevokeAdminFromChannel(token, selectedChannel.channelID, user.id)
      .then((res) => {
        if (res.data.status) {
          const upd = [...users];
          user.isAdmin = false;
          setUsers(upd);
        }
      })
      .catch(() => setUsers([]));
  };

  const handleAcceptUser = (user) => {
    Services.SocialHiveAcceptUserToPrivateChannel(token, selectedChannel.channelID, user.id)
      .then((res) => {
        if (res.data.status) {
          getChannelUsers();
          getChannelUserRequests();
        }
      })
      .catch(() => setUsers([]));
  };

  const handleRejectUser = (user) => {
    Services.SocialHiveRejectUserToPrivateChannel(token, selectedChannel.channelID, user.id)
      .then((res) => {
        if (res.data.status) {
          getChannelUsers();
          getChannelUserRequests();
        }
      })
      .catch(() => setUsers([]));
  };

  const handleAddUser = () => {
    if (!newUser) return;
    setUsers((prev) => [...prev, { name: newUser, role: roleTypes[0]?.name || '', isAdmin: false }]);
    setNewUser('');
  };

  const url = `lodos.sh/channel/${selectedChannel.channelURI}`;
  const handleCopy = () => {
    navigator.clipboard.writeText("https://" + url)
      .then(() => {
        toastSuccess(getTranslation("copiedToClipboard"));
      })
      .catch((err) => {
        console.error('Kopyalama başarısız:', err);
      });
  };

  // ----------------------
  // UniversalTable Columns
  // ----------------------

  // CREATE tab: permission matrix
  const createColumns = useMemo(() => ([
    { key: 'perm', header: getTranslation("authorizationNames") },
    {
      key: 'checked',
      header: getTranslation("authorizationPermission"),
      align: 'center',
      render: (row) => (
        <input
          type="checkbox"
          className="sh-settings-permission-checkbox"
          checked={selectedPermissions.includes(row.perm)}
          onChange={() => handlePermissionChange(row.perm)}
        />
      ),
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ]), [getTranslation, selectedPermissions]);

  const createData = useMemo(() => permissions.map((p) => ({ perm: p })), [permissions]);

  // LIST tab: role types
  const listColumns = useMemo(() => ([
    {
      key: 'color',
      header: '',
      width: 48,
      render: (row) => (
        <span className="sh-settings-role-color" style={{ backgroundColor: row.color }} />
      ),
      align: 'left',
    },
    { key: 'name', header: getTranslation("authorizationTypes") },
    {
      key: 'actions',
      header: '',
      width: 96,
      align: 'right',
      render: (_row, i) => (
        <div className="sh-settings-role-actions">
          <FiTrash2 size={16} onClick={() => handleDeleteRole(i)} />
          <FiEdit2 size={16} onClick={() => handleEditRole(i)} />
        </div>
      ),
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ]), [getTranslation]);

  const listData = useMemo(() => roleTypes, [roleTypes]);

  // ASSIGN tab: users & admin toggle
  const assignColumns = useMemo(() => ([
    {
      key: 'fullName',
      header: getTranslation("name"),
      render: (row) => `${row.name ?? ''} ${row.lastname ?? ''}`.trim()
    },
    {
      key: 'admin',
      header: getTranslation("admin"),
      align: 'right',
      headerClassName: "text-right",
      render: (row) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 55 }}>
          {!row.isOwner && (
            <button
              onClick={() => handleRejectUser(row)}
              className="collaborators-table-reject-button"
            >
              {getTranslation("removeUser")}
            </button>
          )}
          <input
            disabled={row.isOwner}
            type="checkbox"
            className="sh-settings-checkbox"
            checked={!!row.isAdmin}
            onChange={() => toggleAdmin(row)}
          />
        </div>
      ),
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ]), [getTranslation, users]);

  const assignData = useMemo(() => users, [users]);

  // REQUESTS tab: pending users
  const requestsColumns = useMemo(() => ([
    {
      key: 'fullName',
      header: getTranslation("name"),
      render: (row) => `${row.name ?? ''} ${row.lastname ?? ''}`.trim(),
    },
    {
      key: 'actions',
      header: '',
      align: 'right',
      render: (row) => (
        <div className="collaborators-table-status-holder" style={{ justifyContent: 'flex-end' }}>
          <button
            onClick={() => handleAcceptUser(row)}
            className="collaborators-table-accept-button"
          >
            {getTranslation("accept")}
          </button>
          <button
            onClick={() => handleRejectUser(row)}
            className="collaborators-table-reject-button"
          >
            {getTranslation("reject")}
          </button>
        </div>
      ),
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ]), [getTranslation, pendingUsers]);

  const requestsData = useMemo(() => pendingUsers, [pendingUsers]);

  const getRowKey = (row, idx) => String(row.id ?? row.userID ?? row.name ?? idx);

  return (
    <div className="sh-settings-main">
      <div className="sh-settings-tabs">
        {['assign', 'requests'].map(tab => (
          <div
            key={tab}
            className={`sh-settings-tab ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab === 'assign' ? getTranslation("authorize") : getTranslation("pendingList")}
          </div>
        ))}
      </div>

      <div className="sh-settings-content">
        <div className='sh-invite-box'>
          <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className='sh-invite-box-left'>
              <div className='sh-invite-box-title'>
                {getTranslation("growYourCommunity")}
              </div>
              <div className='sh-invite-box-description'>
                {getTranslation("communityGrowthDescription")}
              </div>
            </div>
            <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '15px' }}>
              <span title={getTranslation("copyInviteLink")} onClick={handleCopy} className='sh-invite-box-button'>
                {getTranslation("invite")}
              </span>
            </div>
          </div>

          <div style={{ width: '100%', height: '1px', backgroundColor: 'var(--sh-settings-side-header-border)', marginTop: '15px', marginBottom: '15px' }} />

          <div className='sh-invite-box-description' style={{ fontSize: '11px', display: 'flex', width: '100%', justifyContent: 'center' }}>
            <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
              <div className='sh-invite-box-description' style={{ gap: '25px', display: 'flex' }}>
                <span>{getTranslation("memberCount")}: {users.length}</span>
              </div>
              <span>
                {getTranslation("dailyUserReport")}
              </span>

              <span style={{ flexDirection: 'row', display: 'flex', gap: '15px' }}>
                {getTranslation("joined")}: {userJoinedLeft.joinned}
                <div style={{ width: '2px', height: '15px', backgroundColor: 'var(--sh-settings-side-header-border)' }} />
                {getTranslation("left")}: {userJoinedLeft.leaved}
              </span>
            </span>
          </div>
        </div>

        {activeTab === 'create' && (
          <div className="sh-settings-create">
            <span className='sh-settings-title'>{getTranslation("createAuthorizationType")}</span>

            <div className="sh-settings-input-group">
              <SHInput
                placeholder={getTranslation("nameAuthorization")}
                value={roleName}
                onChange={e => setRoleName(e.target.value)}
              />
              <div className="custom-select-container">
                <select
                  value={roleColor}
                  onChange={e => setRoleColor(e.target.value)}
                >
                  {colorOptions.map(o => (
                    <option key={o.value} value={o.value}>{o.name}</option>
                  ))}
                </select>
                <span className="dropdown-icon"><FiChevronDown /></span>
              </div>
            </div>

            <UniversalTable
              data={createData}
              columns={createColumns}
              getRowKey={(row) => row.perm}
              tableClassName="sh-settings-table"
              emptyText={getTranslation("noData")}
            />

            <button className="sh-settings-action-button" onClick={handleCreateRole}>
              {getTranslation("createAuthorization")}
            </button>
          </div>
        )}

        {activeTab === 'list' && (
          <div className="sh-settings-list">
            <span className='sh-settings-title'>{getTranslation("authorizationTypes")}</span>

            <UniversalTable
              data={listData}
              columns={listColumns}
              getRowKey={(row, i) => String(row.name ?? i)}
              tableClassName="sh-settings-table"
              emptyText={getTranslation("noData")}
            />
          </div>
        )}

        {activeTab === 'assign' && (
          <div className="sh-settings-assign">
            {/* Eğer tekrar açarsan:
            <div className="sh-settings-input-group">
              <SHInput
                placeholder={getTranslation("username")}
                value={newUser}
                onChange={e => setNewUser(e.target.value)}
              />
              <button className="sh-settings-button-add" onClick={handleAddUser}>
                {getTranslation("addToList")}
              </button>
            </div>
            */}

            <UniversalTable
              data={assignData}
              columns={assignColumns}
              getRowKey={getRowKey}
              tableClassName="sh-settings-table"
              emptyText={getTranslation("noData")}
            />
          </div>
        )}

        {activeTab === 'requests' && (
          <div className="sh-settings-assign">
            <UniversalTable
              data={requestsData}
              columns={requestsColumns}
              getRowKey={getRowKey}
              tableClassName="sh-settings-table"
              emptyText={getTranslation("noData")}
            />
          </div>
        )}
      </div>
    </div>
  )
}